import { useEffect } from 'react'
import styles from './Drawer.module.css'
import classNames from 'classnames'

interface DrawerProps {
    open: boolean
    onClose: (event: any) => void
    position?: 'left' | 'right' | 'top' | 'bottom'
    children?: React.ReactNode
    className?: string
    overlay?: boolean
}

export const Drawer = (props: DrawerProps) => {
    const {
        open,
        onClose,
        position = 'left',
        children,
        className = '',
        overlay = true
    } = props

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }

        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [
        open
    ])

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose(e)
        }
    }

    const drawerOverlayClasses = classNames(styles.Drawer__DrawerOverlay, {
        [styles[`Drawer__DrawerOverlay--Active`]]: overlay
    })

    if (!open) return null

    return (
        <div 
            className={drawerOverlayClasses}
            onClick={handleOverlayClick}
        >
            <div className={styles.Drawer}>
                <div className={styles.Drawer__Content}>
                    {children && children}
                </div>
            </div>
        </div>
    )
}
